import { render, staticRenderFns } from "./ExpressoesMain.vue?vue&type=template&id=43570499&scoped=true&"
import script from "./ExpressoesMain.vue?vue&type=script&lang=js&"
export * from "./ExpressoesMain.vue?vue&type=script&lang=js&"
import style0 from "./ExpressoesMain.vue?vue&type=style&index=0&id=43570499&prod&lang=scss&"
import style1 from "./ExpressoesMain.vue?vue&type=style&index=1&id=43570499&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43570499",
  null
  
)

export default component.exports